"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
var pn_any_reference_based_types_1 = require("./pn-any-reference-based-types");
Object.defineProperty(exports, "ACTION", { enumerable: true, get: function () { return pn_any_reference_based_types_1.ACTION; } });
//# sourceMappingURL=pn-any-stream-reference-based-types.js.map